<template>
  <div>
    <v-btn
      v-if="!user"
      :color="buttonColor"
      outlined
      rounded
      @click="sendToLoginPage"
    >
      {{ $t('components.UserMenu.label.login') }}
    </v-btn>

    <v-menu
      v-else
      offset-y
      light
      transition="slide-y-transition"
    >
      <template #activator="{on}">
        <StUserAvatar
          size="32"
          :user="user"
          user-image-path="avatarUrl"
          class="pointer"
          v-on="on"
        />
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title>
            {{ $t('components.UserMenu.label.greeting') }}, <b>{{ user.name }}</b>
          </v-list-item-title>

          <v-spacer />
        </v-list-item>

        <v-divider />

        <v-list-item
          v-for="item in allowItems"
          :key="item.label"
          :title="item.label"
          @click="item.action"
        >
          <v-list-item-action class="mr-2">
            <StIcon
              v-if="item.iconName"
              :icon-name="item.iconName"
            />

            <img
              v-else
              alt="icon"
              :src="item.icon"
            >
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.label }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <ConfigModal v-model="showConfig" />
    <ComponentBuildModal v-if="showComponentBuildModal" />
  </div>
</template>

<script>
import { auth } from 'firebase/app';
import { logout } from '@stilingue/st-auth-utils';
import { mapGetters, mapMutations, mapState } from 'vuex';
import StIcon from '@stilingue/st-icon';
import StUserAvatar from '@stilingue/st-user-avatar';
import ConfigModal from '@/components/config/ConfigModal';
import ComponentBuildModal from '@/components/ComponentBuildModal';
import { MUTATE } from '@/store/modules/mutation_types';
import { Flags } from '@/plugins/rollout';
import { trackEventWithUserProperties } from '@/utils/mixpanel';

import addChartIcon from '@/assets/icons/add_chart.svg';

export default {
  name: 'UserMenu',
  components: {
    StIcon,
    StUserAvatar,
    ConfigModal,
    ComponentBuildModal,
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return [
        {
          label: this.$t('components.UserMenu.label.item.config'),
          iconName: 'cog',
          action: this.openConfiguration,
        },
        {
          label: this.$t('components.UserMenu.label.item.createComponent'),
          icon: addChartIcon,
          action: this.openComponentBuildModal,
          featureFlag: Flags.showComponentBuilder,
        },
        {
          label: this.$t('components.UserMenu.label.item.exit'),
          iconName: 'logout',
          action: this.logout,
        },
      ];
    },
    ...mapState('misc', [
      'showConfig',
      'showComponentBuildModal',
    ]),
    ...mapState('user', [
      'user',
    ]),
    ...mapState('filter', [
      'accountId',
      'universeId',
    ]),
    ...mapGetters('featureFlag', [
      'isEnabled',
    ]),
    allowItems() {
      return this.items.filter(({ featureFlag }) => {
        if (featureFlag) {
          return this.isEnabled(featureFlag);
        }

        return true;
      });
    },
    buttonColor() {
      return this.$vuetify.theme.dark ? 'white' : 'black';
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    async logout() {
      await auth().signOut();
      logout();
      this.sendToLoginPage();
    },
    openConfiguration() {
      this.mutateMisc({
        property: 'showConfig',
        with: true,
      });
    },
    openComponentBuildModal() {
      this.mutateMisc({
        property: 'showComponentBuildModal',
        with: true,
      });

      trackEventWithUserProperties('ST Dashboard ComponentBuilderMenu Open');
    },
    sendToLoginPage() {
      return this.$router.push({
        name: 'login',
        params: {
          accountId: this.accountId,
          universeId: this.universeId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .pointer {
    cursor: pointer;
  }
</style>
